import { useNavigate } from "react-router-dom";

const FORMS = [
  { ic: "🛂", title: "Employment Visa Request", desc: "For Korean nationals with a confirmed role or assignment on the Papua LNG Project who need help with work permit and visa steps.", to: "/apply/visa", who: "Individuals — confirmed role" },
  { ic: "🧰", title: "Job Seekers", desc: "For Korean workers and tradespeople seeking a role on the Papua LNG Project. Upload your CV and certificates to register interest.", to: "/apply/jobs", who: "Individuals — seeking work" },
  { ic: "🏢", title: "Korean Companies — Subcontract Submission", desc: "For Korean companies with capability relevant to the Papua LNG upstream construction and logistics scope.", to: "/apply/company", who: "Companies — Papua LNG scope" },
  { ic: "🌏", title: "General Business Interest", desc: "For Korean companies interested in other Papua New Guinea projects and opportunities beyond Papua LNG.", to: "/apply/general", who: "Companies — other PNG projects" },
];

export default function ApplyHubPage() {
  const navigate = useNavigate();
  return (
    <>
      <div className="pg-hdr">
        <h1>Apply &amp; Register</h1>
        <p>Choose the form that matches your situation. All submissions are reviewed by the portal's team.</p>
      </div>

      <section className="sec">
        <div className="container">
          <div className="grid2">
            {FORMS.map(f => (
              <button key={f.to} className="card" onClick={() => navigate(f.to)}>
                <div className="card-body">
                  <span className="tag tg">{f.who}</span>
                  <div className="card-ic">{f.ic}</div>
                  <h3>{f.title}</h3>
                  <p>{f.desc}</p>
                  <div className="card-more">Open form →</div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
